// 导入vue
import Vue from 'vue'

// 导入路由对象（npm i vue-router@3下载的就这玩意
import VueRouter from 'vue-router'

// 让vue使用路由对象
Vue.use(VueRouter)

// 导入要路由的组件
import Home from '../components/Home.vue'
import Yacht from '../components/Yacht.vue'
import BoatHouse from '../components/BoatHouse.vue'
import GiftHouse from '../components/GiftHouse.vue'
import Furniture from '../components/Furniture.vue'
import Outdoor from '../components/Outdoor.vue'
import Projects from '../components/Projects.vue'
import Project from '../components/Project.vue'
import BrandStory from '../components/BrandStory.vue'
import News from '../components/News.vue'
import New from '../components/New.vue'
import ContactUs from '../components/ContactUs.vue'
import FormSubmit from '../components/FormSubmit.vue'
import ProjectOne from '../components/ProjectOne.vue'
import ProjectTwo from '../components/ProjectTwo.vue'
import Projectdetail from '../components/Projectdetail.vue'

// 定义路由（规则
const routes = [
  { path: '/', component: Home },
  { path: '/yacht/:id', component: Yacht },
  { path: '/boat-house', component: BoatHouse },
  { path: '/gift-house', component: GiftHouse },
  { path: '/furniture', component: Furniture },
  { path: '/outdoor', component: Outdoor },
  { path: '/projects', component: Projects },
  { path: '/project/:type/:smalltype/:id', component: Project },
  { path: '/brand-story', component: BrandStory },
  { path: '/news',component: News },
  { path: '/news/:id',component: New },
  { path: '/contact-us', component: ContactUs, alias: '/Contact-us' },
  { path: '/form-submit', component: FormSubmit },
  // { path: '/project-one/:type', component: ProjectOne },
  { path: '/project-one/:type/:smalltype/:parent_id', component: ProjectOne },
  { path: '/project-two/:type/:smalltype/:id', component: ProjectTwo },
  { path: '/project-detail/:id', component: Projectdetail}

]

// 创建路由router实例,传入路由（规则
const router = new VueRouter({
  routes // (js基础知识，缩写) 相当于 routes: routes,当对象名称与对象值同名时，可以这么简写
})
const originalPush = VueRouter.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 暴露路由router实例，供main.js使用
export default router